// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    customerName: t.Bool,
    failurePart: t.Bool,
    pin: t.Bool,
    programName: t.Bool,
    repairDate: t.Bool,
    responsibleAccount: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool,
    workOrderOne: t.Bool

}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    customerName: true,
    failurePart: true,
    pin: true,
    programName: true,
    repairDate: true,
    responsibleAccount: true,
    useAmount: true,
    useAmountUnit: true,
    workOrderOne: true

});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/incentive/state/form-validation.js